import React, { ReactElement } from 'react';
import './Info.scss';

const Et: React.FC = (): ReactElement => {
  return (
    <div className="Et ruleset-wrapper">
      <ol>
        <li>
          Käesoleva vormi kaudu töötleb Tervisekassa pildi üleslaadija
          isikuandmeid. Isikuandmetena käsitletakse vaid fotodel tuvastatavaid
          isikuid. Pildi üleslaadimine on vabatahtlik.
        </li>
        <li>
          Üleslaetaval pildil tohib olla kujutatud ainult üleslaadija enda isik.
          Juhul kui pilt kujutab teist isikut, on pildi üleslaadija kohustatud
          tagama, et pildil kujutatud isik on andnud nõusoleku selle
          kasutamiseks Tervisekassa 2026. aasta fotokollaažis.
        </li>
        <li>
          Pildi üleslaadija omab pildi autoriõigusi või on tal olemas pildi
          autori kirjalik nõusolek pildi üleandmiseks Tervisekassale.
        </li>
        <li>
          Pilte säilitatakse kuni 31.03.2027. Pärast seda Tervisekassa hävitab
          kogutud pildid.
        </li>
        <li>
          Pildi üleslaadijal on õigus võtta oma nõusolek igal ajal tagasi, ilma
          et see mõjutaks enne tagasivõtmist toimunud töötlemise seaduslikkust.
          Nõusoleku tagasivõtmiseks on vajalik loodud ja allalaaditud
          meeldetuletuse säilitamine. Nõusoleku tagasivõtmiseks tuleb pööruda
          Tervisekassa poole e-maili aadressil{' '}
          <a href="mailto:soeluuring@tervisekassa.ee">
            soeluuring@tervisekassa.ee{' '}
          </a>{' '}
          ning saata koos pöördumisega tagasivõetava pildiga loodud
          meeldetuletus.
        </li>
        <li>
          Küsimuste korral saab võtta ühendust Tervisekassaga e-maili aadressil{' '}
          <a href="mailto:soeluuring@tervisekassa.ee">
            soeluuring@tervisekassa.ee
          </a>
          .
        </li>
        <li>
          Pilti kasutatakse ainult Tervisekassa 2026. aasta fotokollaažis eraldi
          nõusoleku andmisel <a href="/">SIIN</a> kuni 31.03.2027.
        </li>
      </ol>
    </div>
  );
};

export default Et;
